import React, { useEffect, useState, useMemo } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { format } from 'date-fns'
import { Plus } from 'lucide-react'

import Loading from '../components/Loading'
import DataTable from '../components/DataTable'
import { getRoles } from '../actions/roleActions'
import { GET_ROLES_RESET } from '../constants/roleConstants'

const Roles = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([])
  const [addRoleOption, setAddRoleOption] = useState(true)
  const [loading, setLoading] = useState(true)

  const dispatch = useDispatch()

  // Check for auth
  const userLogin = useSelector((state) => state.userLogin)
  const { userInfo } = userLogin

  useEffect(() => {
    if (!userInfo) {
      navigate('/')
    }
  }, [userInfo, navigate])

  // Check for role
  const getRoleInfo = useSelector((state) => state.getRoleInfo)
  const { getRoleData } = getRoleInfo

  useEffect(() => {
    if (getRoleData) {
      setAddRoleOption(getRoleData.rolesAdd)
      if (!getRoleData.rolesView) {
        toast('Not Authorized', {
          type: 'error',
          hideProgressBar: true,
          autoClose: 2000,
      })
        navigate('/')
      }
    }
  }, [getRoleData, navigate])

  useEffect(() => {
    dispatch(getRoles())
  }, [dispatch])

  // Get Roles
  const getRolesInfo = useSelector((state) => state.getRolesInfo)
  const { errorGetRolesInfo, getRolesData } = getRolesInfo

  useEffect(() => {
    dispatch({ type: GET_ROLES_RESET })
    if (getRolesData) {
      setLoading(false)
      setData(getRolesData)
    } else if (errorGetRolesInfo) {
      setLoading(false)
      toast(errorGetRolesInfo, {
        type: 'error',
        hideProgressBar: true,
        autoClose: 2000,
      })
    }
  }, [getRolesData, errorGetRolesInfo, dispatch])

  // Table columns
  const columns = useMemo(
    () => [
      {
        accessorKey: 'name',
        header: 'Name',
        cell: ({ row }) => (
          <Link
            className='font-bold text-md cursor-pointer text-blue-800 bg-blue-100 px-3 py-1 rounded inline-block hover:bg-blue-200 transition-colors'
            to={`/roles/update/${row.original._id}`}
          >
            {row.original.name}
          </Link>
        ),
      },
      {
        accessorKey: 'createdAt',
        header: 'Created At',
        cell: ({ row }) => {
          try {
            return format(new Date(row.original.createdAt), 'dd-MM-yyyy HH:mm:ss')
          } catch (error) {
            return row.original.createdAt
          }
        },
      },
    ],
    []
  )

  if (loading) {
    return <Loading />
  }

  return (
    <div className='w-full h-full'>
      <h1 className='text-2xl font-semibold mb-4'>Roles</h1>

      <DataTable
        data={data}
        columns={columns}
        title="Role Management"
        isLoading={loading}
        toolbar={
          addRoleOption && (
            <Link
              className='bg-green-500 hover:bg-green-700 text-white text-sm font-semibold py-2 px-4 rounded focus:outline-none focus:shadow-outline flex items-center gap-2'
              to='/roles/add'
            >
              <Plus size={16} />
              Add Role
            </Link>
          )
        }
      />
    </div>
  )
}

export default Roles
